"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _SttLabel = _interopRequireDefault(require("../SttTypography/SttLabel"));
var _SttText = _interopRequireDefault(require("../SttTypography/SttText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    div: {
      padding: '1px'
    }
  };
});
var SttTextItem = function SttTextItem(_ref) {
  var title = _ref.title,
    content = _ref.content,
    classContent = _ref.classContent,
    wrapperClass = _ref.wrapperClass;
  var classes = useStyles();
  var conteudoFormatado = '';
  if (!Array.isArray(content)) {
    conteudoFormatado = content;
  } else {
    conteudoFormatado = content.map(function (e) {
      return e.descricao || e.nome;
    }).join(', ');
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperClass || classes.div
  }, /*#__PURE__*/_react["default"].createElement(_SttLabel["default"], {
    variant: "body2",
    color: "primary",
    style: {
      wordBreak: 'break-word'
    }
  }, title), /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    variant: "body2",
    className: classContent,
    style: {
      wordBreak: 'break-word'
    }
  }, conteudoFormatado));
};
var _default = SttTextItem;
exports["default"] = _default;